import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionMoveCardToStageCodes = {
  AutomationV2ExecutionActionMoveCardToStageFailedToMoveCard: {
    code: 'automation-v2-execution-action/move-card-to-stage-failed-to-move-card',
    explanation: `Falha ao tentar mover o card de fase.

**Causas comuns:**
- Violação de regras de movimentação (campos obrigatórios não preenchidos)
- Fase de destino inválida ou arquivada
- Usuário da automação sem permissão para mover card

**Como diagnosticar:**
Verifique se todas as regras da fase de destino são atendidas pelos dados atuais do card.`,
    localizations: {},
    message: 'A automação não conseguiu mover o processo para a etapa especificada.',
    supportingDocs: [
      {
        name: 'Ação de Mover Card para Etapa',
        path: '/wiki/docs/automations/actions/move-card-to-stage',
      },
      {
        name: 'Configuração de Etapas',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  AutomationV2ExecutionActionMoveCardToStageMissingCardId: {
    code: 'automation-v2-execution-action/move-card-to-stage-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível mover o card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Mover Card para Etapa',
        path: '/wiki/docs/automations/actions/move-card-to-stage',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionMoveCardToStageMissingStageId: {
    code: 'automation-v2-execution-action/move-card-to-stage-missing-stage-id',
    explanation: `ID da etapa de destino não configurado.

**Causas comuns:**
- Etapa não selecionada na configuração
- Etapa removida do fluxo

**Como resolver:**
Selecione uma etapa de destino válida.`,
    localizations: {},
    message:
      'Não foi possível mover o card porque o ID da etapa está faltando. Verifique se a etapa existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Mover Card para Etapa',
        path: '/wiki/docs/automations/actions/move-card-to-stage',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
